import endpoint from "../../config/endpoints";
import dayjs from "dayjs";

export const OrderClosingJson = {
  formPath: "/order-closing",
  apiBaseURL: endpoint.area,
  screenTitle: "Lost Order",

  tableColumnsToFilter: [
    {
      columnDisplayName: "Outlet Name",
      columnKeyName: "firmName",
      isChecked: true,
    },
    {
      columnDisplayName: "Sales Person Name",
      columnKeyName: "salesTeamName",
      isChecked: true,
    },
    {
      columnDisplayName: "Product Name",
      columnKeyName: "productName",
      isChecked: true,
    },
    {
      columnDisplayName: "Order No",
      columnKeyName: "orderNo",
      isChecked: true,
    },
    {
      columnDisplayName: "Order Date",
      columnKeyName: "orderDate",
      isChecked: true,
    },
    {
      columnDisplayName: "Order Quantity",
      columnKeyName: "totalQty",
      isChecked: true,
    },
    {
      columnDisplayName: "Taxable Amt",
      columnKeyName: "taxableAmt",
      isChecked: true,
    },
    {
      columnDisplayName: "CGST",
      columnKeyName: "cgstAmt",
      isChecked: true,
    },
    {
      columnDisplayName: "SGST",
      columnKeyName: "sgstAmt",
      isChecked: true,
    },
    {
      columnDisplayName: "Total",
      columnKeyName: "total",
      isChecked: true,
    },
  ],

  fieldMetaBySalsPerson: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      getListId: "flag",
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Outlet wise",
          value: "0",
        },
        {
          label: "Sales Person wise",
          value: "1",
        },
      ],
      isMandatory: true,
    },
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromdate",
      defaultValue: dayjs(),
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      defaultValue: dayjs(),
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    },
    {
      label: "Beat",
      controlType: "multiSelect",
      placeHolder: "Select Beat",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "beat",
      masterName: "beatDetail",
      getListId: "beat",
      isMandatory: true,
      isRootLevelKey: false,
    },
    {
      label: "Sales person",
      controlType: "multiSelect",
      placeHolder: "Select Sales Person",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "salesPersonIds",
      getListFrom: "beat",
      masterName: "salesPersonDetail",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
  fieldMeta: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      getListId: "flag",
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Outlet wise",
          value: "0",
        },
        {
          label: "Sales Person wise",
          value: "1",
        },
      ],
      isMandatory: true,
    },
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromdate",
      defaultValue: dayjs(),
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      defaultValue: dayjs(),
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    },
    {
      label: "Beat",
      controlType: "multiSelect",
      placeHolder: "Select Beat",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "beat",
      masterName: "beatDetail",
      getListId: "beat",
      isMandatory: true,
      isRootLevelKey: false,
    },
    {
      label: "Outlet",
      controlType: "multiSelect",
      placeHolder: "Select Outlet",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "outletIds",
      getListFrom: "beat",
      masterName: "outletDetail",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
  searchListBySalsPerson: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      getListId: "flag",
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Outlet wise",
          value: "0",
        },
        {
          label: "Sales Person wise",
          value: "1",
        },
      ],
      isMandatory: true,
    },
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromdate",
      defaultValue: dayjs(),
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      defaultValue: dayjs(),
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    },
    {
      label: "Beat",
      controlType: "multiSelect",
      placeHolder: "Select Beat",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "beat",
      masterName: "beatDetail",
      getListId: "beat",
      isMandatory: true,
      isRootLevelKey: false,
    },
    {
      label: "Sales person",
      controlType: "multiSelect",
      placeHolder: "Select Sales Person",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "salesPersonIds",
      getListFrom: "beat",
      masterName: "salesPersonDetail",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Product",
      controlType: "multiSelect",
      placeHolder: "Select Product",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "productIds",
      masterName: "productDetail",
      isMandatory: true,
      isRootLevelKey: false,
    },
  ],
  searchList: [
    {
      label: "Search By",
      controlType: "radiogroup",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      getListId: "flag",
      dataKey: "flag",
      tableDataKey: "Outlet wise",
      defaultValue: "0",
      radioGroupItems: [
        {
          label: "Outlet wise",
          value: "0",
        },
        {
          label: "Sales Person wise",
          value: "1",
        },
      ],
      isMandatory: true,
    },
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromdate",
      defaultValue: dayjs(),
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      defaultValue: dayjs(),
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    },
    {
      label: "Beat",
      controlType: "multiSelect",
      placeHolder: "Select Beat",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "beat",
      masterName: "beatDetail",
      getListId: "beat",
      isMandatory: true,
      isRootLevelKey: false,
    },
    {
      label: "Outlet",
      controlType: "multiSelect",
      placeHolder: "Select Outlet",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "outletIds",
      getListFrom: "beat",
      masterName: "outletDetail",
      isRootLevelKey: true,
      isMandatory: true,
    },
    {
      label: "Product",
      controlType: "multiSelect",
      placeHolder: "Select Product",
      md: 12,
      lg: 12,
      sm: 12,
      xs: 12,
      labelXS: 12,
      labelSM: 2,
      labelMD: 2,
      labelLG: 2,
      valueXS: 12,
      valueSM: 10,
      valueMD: 10,
      valueLG: 10,
      dataKey: "productIds",
      masterName: "productDetail",
      isMandatory: true,
      isRootLevelKey: false,
    },
  ],
};
